import React, { useEffect, useState } from 'react';
import { Fragment } from 'react';
import { Disclosure, Menu, Transition } from '@headlessui/react';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import _ from 'lodash';
import logoB from '../../assets/tripaide-logo-b.svg';
import logoW from '../../assets/tripaide-logo-w.svg';
import { FaCaretRight } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { auth } from '../../firebase.init';
import useUsers from '../../hooks/useUsers';

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const navigation = [
    { name: 'home', current: false },
    { name: 'feed', current: false },
    { name: 'offers', current: false },
]

const Navbar = ({ currentPage }) => {

    const [user, setUser] = useState({});
    const [users] = useUsers();
    //console.log(users);

    let navigate = useNavigate();

    useEffect(() => {
        onAuthStateChanged(auth, (user) => {
            if (user) {
                setUser(user);
                //console.log(user);
            } else {
                setUser({});
            }
        });
    }, [])

    const handleEditProfile = () => {
        const id = users?.find(u => u.email === user.email)?._id;
        //console.log(id);
        navigate(`/u/${id}`);
    }

    const handleSignOut = () => {
        signOut(auth).then(() => {
            // Sign-out successful.
            navigate('/');
        }).catch((error) => {
            // An error happened.
        });
    }

    _.chain(navigation)
        .find({ name: currentPage })
        .merge({ current: true }).value();

    const [logo, setLogo] = useState('');
    useEffect(() => {
        const logoCurrent = currentPage === 'home' ? logoW : logoB;
        setLogo(logoCurrent);
    }, [currentPage]);

    const handleMenuPic = () => {
        this.src = 'https://cdn-icons-png.flaticon.com/512/3899/3899618.png';
    }

    return (
        <Disclosure as="nav" className="">
            {({ open }) => (
                <div>
                    <div className="mx-auto w-11/12 px-2 sm:px-6 lg:px-8">
                        <div className="relative flex h-16 items-center justify-between">
                            <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
                                <Disclosure.Button className="inline-flex items-center justify-center rounded-md p-2 text-gray-400 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                                    {open ? (
                                        <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                                    ) : (
                                        <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                                    )}
                                </Disclosure.Button>
                            </div>
                            <div className="flex flex-1 items-center justify-center sm:items-stretch sm:justify-between">
                                <Link to="/" className="flex flex-shrink-0 items-center">
                                    <img
                                        className="block h-8 w-32 lg:hidden cursor-pointer"
                                        src={logo}
                                        alt="tripaide"
                                    />
                                    <img
                                        className="hidden h-8 w-32 lg:block cursor-pointer"
                                        src={logo}
                                        alt="tripaide"
                                    />
                                </Link>
                                <div className="hidden sm:ml-6 sm:block">
                                    <div className="flex space-x-4">
                                        {navigation.map((item) => (
                                            <Link to={`/${item.name}`}
                                                key={item.name}
                                                href={item.href}
                                                className={classNames(
                                                    item.current ? 'text-yellow-500' : 'text-gray-400 hover:text-yellow-500',
                                                    'px-3 py-2 font-semibold cursor-pointer capitalize'
                                                )}
                                            >
                                                {item.name}
                                            </Link>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">

                                {/* Profile dropdown */}
                                {
                                    user.email ? (
                                        <Menu as="div" className="relative ml-3">
                                            <div>
                                                <Menu.Button className="flex rounded-full bg-gray-800 text-sm focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">
                                                    <span className="sr-only">Open user menu</span>
                                                    <img className="h-8 w-8 rounded-full"
                                                        src={users?.find(u => u?.email === user?.email)?.img} alt="propic"
                                                        onError={handleMenuPic}
                                                    />
                                                </Menu.Button>
                                            </div>
                                            <Transition
                                                as={Fragment}
                                                enter="transition ease-out duration-100"
                                                enterFrom="transform opacity-0 scale-95"
                                                enterTo="transform opacity-100 scale-100"
                                                leave="transition ease-in duration-75"
                                                leaveFrom="transform opacity-100 scale-100"
                                                leaveTo="transform opacity-0 scale-95"
                                            >
                                                <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                                    <Menu.Item>
                                                        {({ active }) => (
                                                            <at onClick={handleEditProfile}
                                                                className={classNames(active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700 cursor-pointer')}
                                                            >
                                                                Your Profile
                                                            </at>
                                                        )}
                                                    </Menu.Item>
                                                    <Menu.Item>
                                                        {({ active }) => (
                                                            <Link to='/editprofile'
                                                                className={classNames(active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700 cursor-pointer')}
                                                            >
                                                                Settings
                                                            </Link>
                                                        )}
                                                    </Menu.Item>
                                                    <Menu.Item>
                                                        {({ active }) => (
                                                            <Link to='/dashboard'
                                                                className={classNames(active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700 cursor-pointer')}
                                                            >
                                                                Dashboard
                                                            </Link>
                                                        )}
                                                    </Menu.Item>
                                                    <Menu.Item>
                                                        {({ active }) => (
                                                            <p onClick={handleSignOut} className={classNames(active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700 cursor-pointer')} >Sign out </p>
                                                        )}
                                                    </Menu.Item>
                                                </Menu.Items>
                                            </Transition>
                                        </Menu>
                                    ) : (
                                        <Link to='/login' className='bg-yellow-500 text-gray-900 hover:shadow-lg hover:text-white px-3 py-2 rounded-md text-sm font-semibold cursor-pointer'
                                        >
                                            Sign In <FaCaretRight className='inline-block pl-0.5' />
                                        </Link>
                                    )
                                }
                            </div>
                        </div>
                    </div>

                    <Disclosure.Panel className="sm:hidden">
                        <div className="space-y-1 px-2 pt-2 pb-3">
                            {navigation.map((item) => (
                                <Disclosure.Button
                                    key={item.name}
                                    as="span"
                                >
                                    <Link
                                        to={`/${item.name}`}
                                        className={classNames(
                                            item.current ? 'text-yellow-500' : 'text-gray-400 hover:text-yellow-500',
                                            'block px-3 py-2 font-semibold cursor-pointer capitalize'
                                        )}>
                                        {item.name}
                                    </Link>
                                </Disclosure.Button>
                            ))}
                        </div>
                    </Disclosure.Panel>
                </div>
            )
            }
        </Disclosure >
    );
};

export default Navbar;